import { PeopleFill } from "react-bootstrap-icons";
import { ROLE_ADMIN, ROLE_TEACHER } from "app/config/roles";
import { INSTITUTE_TYPES } from "app/config/institutes";
import { ContactEmergency } from "@mui/icons-material";

export const sidebarItems = [
  {
    key: "admission-enquiry",
    name: "Admission Enquiry",
    icon: <ContactEmergency size={15} />,
    roles: [ROLE_ADMIN, ROLE_TEACHER],
    instituteTypes: [INSTITUTE_TYPES.SCHOOL],
    module: "RECEPTION",
    screenName: "ADMISSION_ENQUIRY",
    subMenu: [
      {
        key: "enquiry",
        name: "Enquiry",
        icon: <PeopleFill size={15} />,
        link: `admission-enquiry/enquiry`,
        roles: [ROLE_ADMIN, ROLE_TEACHER],
        instituteTypes: [INSTITUTE_TYPES.SCHOOL],
        module: "RECEPTION",
        screenName: "ADMISSION_ENQUIRY",
      },
      // {
      //   key: "counselor",
      //   name: "Counselor",
      //   icon: <ManageAccounts size={15} />,
      //   link: `admission-enquiry/counselor`,
      //   roles: [ROLE_ADMIN, ROLE_TEACHER],
      //   instituteTypes: [INSTITUTE_TYPES.SCHOOL],
      //   module: "RECEPTION",
      //   screenName: "ADMISSION_ENQUIRY",
      // },
      // {
      //   key: "formFeeStructure",
      //   name: "Form Fee Structure",
      //   icon: <PriceChange size={15} />,
      //   link: `admission-enquiry/formFeeStructure`,
      //   roles: [ROLE_ADMIN, ROLE_TEACHER],
      //   instituteTypes: [INSTITUTE_TYPES.SCHOOL],
      //   module: "RECEPTION",
      //   screenName: "ADMISSION_ENQUIRY",
      // },
      // {
      //   key: "previousSchool",
      //   name: "Previous School",
      //   icon: <HistoryEdu size={15} />,
      //   link: `admission-enquiry/previousSchool`,
      //   roles: [ROLE_ADMIN, ROLE_TEACHER],
      //   instituteTypes: [INSTITUTE_TYPES.SCHOOL],
      //   module: "RECEPTION",
      //   screenName: "ADMISSION_ENQUIRY",
      // },
    ],
  },
  {
    key: "access-control",
    name: "Access Control",
    icon: <PeopleFill size={15} />,
    roles: [ROLE_ADMIN, ROLE_TEACHER],
    instituteTypes: [INSTITUTE_TYPES.SCHOOL],
    module: "ACCESS_CONTROL",
    screenName: "ACCESS_CONTROL",
    subMenu: [
      {
        key: "permission",
        name: "Permission",
        icon: <PeopleFill size={15} />,
        link: "access-control/permission",
        roles: [ROLE_ADMIN, ROLE_TEACHER],
        instituteTypes: [INSTITUTE_TYPES.SCHOOL],
        module: "ACCESS_CONTROL",
        screenName: "PERMISSION",
      },
    ],
  },
];
